/**
 * GlitchManager — global singleton that coordinates all ambient glitch triggers.
 *
 * Rules enforced:
 *  • Only ONE glitch can be active at a time across the entire page.
 *  • A mandatory cooldown (default 1 s) must pass before the next trigger is allowed.
 *  • hover-triggered glitches bypass the ambient lock so they always feel responsive,
 *    but they DO set a short cooldown to prevent rapid-fire overlapping.
 */

class GlitchManager {
    private _isActive = false
    private _cooldownUntil = 0

    /** Attempt to claim the global glitch slot.
     *  Returns `true` if the claim succeeded (caller may play the glitch).
     *  Returns `false` if another glitch is already running or cooldown has not elapsed.
     */
    acquire(cooldownMs = 1000): boolean {
        const now = Date.now()
        if (this._isActive || now < this._cooldownUntil) return false
        this._isActive = true
        this._cooldownUntil = now + cooldownMs
        return true
    }

    /** Release the slot after a glitch finishes.  Call this in every completion path. */
    release(): void {
        this._isActive = false
    }

    /** True while a glitch is actively playing. */
    get isActive(): boolean {
        return this._isActive
    }
}

// Singleton — import this instance everywhere
export const glitchManager = new GlitchManager()
